<app-damage-report-step-header />
<div class="damage-report-card">
    <form [formGroup]="form">
        <div class="grid-container">
            <div class="form-control g-12 sm:g-6">
                <label for="damage-date">Wann ist der Schaden eingetreten?*</label>
                <input
                    id="damage-date"
                    ctrlDateInput
                    formControlName="damageDate"
                    placeholder="tt.mm.jjjj*"
                />
                @let ctrl = form.controls.damageDate;
                @if (ctrl.touched && ctrl.invalid) {
                    @if (ctrl.errors.required) {
                        <span
                            class="form-error-note"
                            aria-live="polite"
                            >Bitte gib an, wann der Schaden eingetreten ist.</span
                        >
                    } @else if (ctrl.errors.dateInvalidError) {
                        <span
                            class="form-error-note"
                            aria-live="polite"
                            >Bitte gib ein gültiges Datum an.</span
                        >
                    } @else if (ctrl.errors.dateAfterError) {
                        <span
                            class="form-error-note"
                            aria-live="polite"
                            >Das Datum darf nicht vor dem Vertragsbeginn liegen.</span
                        >
                    } @else if (ctrl.errors.dateBeforeError) {
                        <span
                            class="form-error-note"
                            aria-live="polite"
                            >Das Datum darf nicht in der Zukunft liegen.</span
                        >
                    }
                }
            </div>

            <div class="form-control g-12">
                <label for="damage-location">Wo kam es zu dem Schaden?*</label>
                <textarea
                    autoresize
                    id="damage-location"
                    formControlName="location"
                    placeholder="Ort*"
                ></textarea>
                @if (form.controls.location.touched && form.controls.location.invalid) {
                    @if (form.controls.location.errors.required) {
                        <span
                            class="form-error-note"
                            aria-live="polite"
                            >Bitte gib an, wo es zu dem Schaden kam.</span
                        >
                    }
                }
            </div>
        </div>

        <app-required-info />

        <app-portal-action-buttons
            [rejectText]="isFirst ? 'Abbrechen' : 'Zurück'"
            (clickReject)="isFirst ? onCancel.emit() : onPrev.emit()"
            (clickConfirm)="onNext.emit()"
            [isConfirmDisabled]="!canGoToNextStep()"
            [isUsedToSubmitForm]="true"
        />
    </form>
</div>
